/**
 * 应用入口组件
 *
 * 配置 React Query Provider 和 Router
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'

import { router } from './routes'

/* ============================================
 * React Query 客户端配置
 * ============================================ */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 数据缓存时间（毫秒）
      staleTime: 5 * 60 * 1000,
      // 缓存保留时间
      gcTime: 10 * 60 * 1000,
      // 窗口重新聚焦时不自动重新请求
      refetchOnWindowFocus: false,
      // 重试次数
      retry: 1,
    },
    mutations: {
      // 变更操作重试次数
      retry: 0,
    },
  },
})

/* ============================================
 * 应用组件
 * ============================================ */

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* 路由 */}
      <RouterProvider router={router} />

      {/* Toast 通知 */}
      <Toaster
        position="top-center"
        richColors
        closeButton
        duration={3000}
      />
    </QueryClientProvider>
  )
}